var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-back fill-height pa-5"},[(_vm.customerId)?_c('AccountBalance',{attrs:{"id":_vm.customerId,"disabled":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }